<template>
  <footer class="footer mt-auto py-2 bg-light shadow-lg">
    <div class="container">
      <p class="text-center text-muted mb-1">
        © {{ date }} <LanguageSwitcher />
      </p>
    </div>
  </footer>
</template>

<script>
import LanguageSwitcher from '@/modules/localization/components/LanguageSwitcher.vue';
import Tr from '@/modules/localization/translation';
export default {
  components: { LanguageSwitcher },
  setup() {
    return { Tr };
  },
  data: () => ({ date: new Date().getFullYear() }),
};
</script>
